/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

import $ from "./app/jquery-shim";

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {

  };
  growApp.prototype.spheader = function () {
    var langButton = $('.l-header__splang');
    var langList = $('.l-header__splang-list');

    var searchButton = $('.l-header__spsearch span');
    var searchform = $('.l-header__spsearch-form');

    langButton.on('click',function () {
      langList.toggleClass('is-active');
      searchform.removeClass('is-active');
    });

    searchButton.on('click',function () {
      langList.removeClass('is-active');
      searchform.toggleClass('is-active');
    });
  };





  $(function () {
    var app = new growApp();
    app.spheader();
  });
})(jQuery);
